// extracted by mini-css-extract-plugin
module.exports = {"social-icons":"SocialMediaRow_social-icons__BSHW2","is-aligned-center":"SocialMediaRow_is-aligned-center__mnyGs"};